import React, { useEffect, useMemo, useState } from "react"
const parse = require('html-react-parser');

export const HtmlOqt = React.memo((props, name) => {
  const html = parse(props.formik.values[name]);
  return (
    <div style={{ padding: 8, width: "100%" }} >
      {html}
    </div> 
  )

})

